interface Dimensions {
    height: number;
    width: number;
}

interface NewDimensions {
    height?: number;
    width?: number;
}

export const scaleImage = (
    originalDimensions: Dimensions,
    newDimensions: NewDimensions,
): Dimensions => {
    const result = {
        height: 0,
        width: 0,
    };

    if (
        newDimensions.height !== undefined &&
        newDimensions.width !== undefined
    ) {
        return {
            height: newDimensions.height,
            width: newDimensions.width,
        };
    }

    if (
        newDimensions.height === undefined &&
        newDimensions.width === undefined
    ) {
        return originalDimensions;
    }

    if (newDimensions.width !== undefined) {
        result.width = newDimensions.width;
        result.height =
            (originalDimensions.height / originalDimensions.width) *
            newDimensions.width;
    }

    if (newDimensions.height !== undefined) {
        result.height = newDimensions.height;
        result.width =
            (originalDimensions.width / originalDimensions.height) *
            newDimensions.height;
    }

    return result;
};
